<template>
  <BlocoFormularioCadastro voltar="/faturamento" @salvar="salvar()">
    <template #toolbar>
      <button
        v-if="exibeFinalizar()"
        id="botaoFinalizar"
        data-test-id="button-botaofinalizarcadastro"
        name="botaoFinalizar"
        type="button"
        class="btn btn-info"
        @click="finalizarFaturamento()"
      >
        <span class="fa fa-calendar" /> Finalizar
      </button>
    </template>
    <template #form>
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <div class="panel panel-primary">
            <div class="panel-heading">
              <h4 class="panel-title">Faturamento</h4>
            </div>
            <div class="panel-body">
              <div class="row">
                <div class="col-xs-12 col-sm-10 col-md-10 col-lg-10">
                  <CampoGenerico
                    id="nomeFaturamento"
                    :label-sup="'(1)'"
                    :valor="faturamento.nome"
                    :validacao="v$.faturamento.nome"
                    :somente-leitura="faturamento._id"
                    label="Nome"
                    @atualizar="faturamento.nome = $event"
                  >
                    <template #mensagensValidacao>
                      <span
                        v-if="!v$.faturamento.nome.required"
                        class="help-block"
                      >
                        Campo é obrigatório.
                      </span>
                    </template>
                  </CampoGenerico>
                </div>
                <div class="col-xs-12 col-sm-2 col-md-2 col-lg-2">
                  <SelecionarSituacao
                    :label-sup="'(1)'"
                    :validacao="v$.faturamento.ativo"
                    :mostrar-todos="false"
                    :valor="faturamento.ativo"
                    @atualizar="faturamento.ativo = $event"
                  >
                    <template #mensagensValidacao>
                      <span
                        v-if="!v$.faturamento.ativo.required"
                        class="help-block"
                      >
                        Campo é obrigatório.
                      </span>
                    </template>
                  </SelecionarSituacao>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12 col-sm-4 col-md-4 col-lg-4">
                  <SelecionarData
                    id="finalizado"
                    :valor="faturamento.finalizado"
                    :somente-leitura="!faturamento.finalizado"
                    label="Data Finalizado"
                    @atualizar="faturamento.finalizado = $event"
                  />
                </div>
                <div class="col-xs-12 col-sm-4 col-md-4 col-lg-4">
                  <SelecionarData
                    id="arquivado"
                    :valor="faturamento.arquivado"
                    :somente-leitura="!faturamento.arquivado"
                    label="Data Arquivado"
                    @atualizar="faturamento.arquivado = $event"
                  />
                </div>
                <div class="col-xs-12 col-sm-4 col-md-4 col-lg-4">
                  <SelecionarData
                    id="glosa"
                    :valor="faturamento.glosa"
                    :somente-leitura="!faturamento.glosa"
                    label="Data Glosa"
                    @atualizar="faturamento.glosa = $event"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="faturamento.guias.length" class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <div class="panel panel-primary">
            <div class="panel-heading">
              <h4 class="panel-title">
                <a role="button" @click.prevent="toggleMostrarAdicionadas">
                  Guias adicionadas ao faturamento
                </a>
                <span class="pull-right contador">{{
                  faturamento.guias.length
                }}</span>
              </h4>
            </div>
            <Collapse v-model="mostrarAdicionadas">
              <div class="panel-body">
                <div class="row">
                  <div
                    v-for="guia in faturamento.guias"
                    :key="guia._id"
                    class="col-xs-12 col-sm-6 col-md-4 col-lg-3"
                  >
                    <GuiaFaturamentoFicha
                      :guia="guia"
                      :mostrar-seletor="false"
                      :mostrar-deletar="true"
                      :mostrar-seletor-agendamentos="true"
                      @selecionarAgendamentos="selecionarAgendamentos"
                      @removerGuia="removerGuia"
                    />
                  </div>
                </div>
              </div>
            </Collapse>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <div class="panel panel-primary">
            <div class="panel-heading">
              <h4 class="panel-title">
                <a role="button" @click.prevent="toggleMostrarAdicionar">
                  Selecionar guias do faturamento
                </a>
              </h4>
            </div>
            <Collapse v-model="mostrarAdicionar">
              <div class="panel-body">
                <div class="row">
                  <div class="col-xs-12 col-sm-2 col-md-2 col-lg-2">
                    <CampoGenerico
                      id="numeroGuia"
                      :valor="filtroGuias.numero"
                      label="Número da Guia"
                      placeholder="ex: 19999999999"
                      mascara="99999999999999999999"
                      @atualizar="atualizarFiltroGuiasNumero"
                    />
                  </div>
                  <div class="col-xs-12 col-sm-2 col-md-2 col-lg-2">
                    <BuscarSelecionarPaciente
                      :minimo="1"
                      label="Paciente / Beneficiário"
                      @selecionadoPaciente="aoSelecionarPacienteFiltro"
                      @limparPaciente="aoLimparPacienteFiltro"
                    />
                  </div>
                  <div class="col-xs-12 col-sm-2 col-md-2 col-lg-2">
                    <SelecionarConvenio
                      @atualizar="atualizarFiltroGuiasConvenio"
                    />
                  </div>
                  <div class="col-xs-12 col-sm-4 col-md-4 col-lg-2">
                    <SelecionarData
                      id="dataEmissoaInicio"
                      label="Data Inicío"
                      @atualizar="atualizarFiltroGuiasDataInicio"
                    />
                  </div>
                  <div class="col-xs-12 col-sm-4 col-md-4 col-lg-2">
                    <SelecionarData
                      id="dataEmissoaFim"
                      label="Data Fim"
                      @atualizar="atualizarFiltroGuiasDataFim"
                    />
                  </div>
                  <div class="col-xs-12 col-sm-2 col-md-2 col-lg-2">
                    <SelecionarEspecialidade
                      @atualizar="atualizarFiltroGuiasEspecialidade"
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-12 col-sm-4 col-md-4 col-lg-4">
                    <button
                      id="botaoLimpar"
                      type="button"
                      class="btn btn-danger"
                      @click="limparFiltroGuias()"
                    >
                      Limpar
                    </button>
                    <button
                      v-if="guiasSelecionadas.length"
                      id="botaoAdicionarGuias"
                      type="button"
                      class="btn btn-success"
                      @click="adicionarGuiaSelecionadas()"
                    >
                      Adicionar {{ guiasSelecionadas.length }} guia(s)
                      selecionada(s)
                    </button>
                  </div>
                  <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                    <Pagination
                      v-if="filtroGuias.total"
                      id="paginadorGuiasFaturamento"
                      v-model="filtroGuias.pagina"
                      :total-page="filtroGuias.total"
                      boundary-links
                      style="margin-top: 2px"
                      @change="paginaAlterada"
                    />
                  </div>
                </div>
                <br />
                <div class="row">
                  <div
                    v-for="guia in guias"
                    :key="guia._id"
                    class="col-xs-12 col-sm-6 col-md-4 col-lg-3"
                  >
                    <GuiaFaturamentoFicha
                      :guia="guia"
                      @guiaToggle="guiaToggle"
                    />
                  </div>
                </div>
              </div>
            </Collapse>
          </div>
        </div>
      </div>
    </template>
  </BlocoFormularioCadastro>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import moment from 'moment'

import BlocoFormularioCadastro from '@/componentes/formulario/BlocoFormularioCadastro'
import BuscarSelecionarPaciente from '@/componentes/formulario/BuscarSelecionarPaciente'
import CampoGenerico from '@/componentes/formulario/CampoGenerico'
import SelecionarConvenio from '@/componentes/formulario/SelecionarConvenio'
import SelecionarData from '@/componentes/formulario/SelecionarData'
import SelecionarEspecialidade from '@/componentes/formulario/SelecionarEspecialidade'
import SelecionarSituacao from '@/componentes/formulario/SelecionarSituacao'
import { useMenu } from '@/composables/useMenu'
import router from '@/router'
import FaturamentoServico from '@/servicos/FaturamentoServico'
import GuiaServico from '@/servicos/GuiaServico'
import MensagemServico from '@/servicos/MensagemServico'

import GuiaFaturamentoFicha from './GuiaFaturamentoFicha'

const guiaServico = new GuiaServico()
const mensagemServico = new MensagemServico()
const faturamentoServico = new FaturamentoServico()

export default {
  name: 'FaturamentoCadastro',
  components: {
    BlocoFormularioCadastro,
    BuscarSelecionarPaciente,
    CampoGenerico,
    SelecionarConvenio,
    SelecionarData,
    SelecionarEspecialidade,
    SelecionarSituacao,
    GuiaFaturamentoFicha,
  },

  setup() {
    useMenu(44)
    return { v$: useVuelidate() }
  },
  data() {
    return {
      guias: [],
      guiasSelecionadas: [],
      guiasRemovidas: [],
      faturamento: {
        nome: moment().format('YYYY_MMMM_ww').toUpperCase(),
        finalizado: '',
        arquivado: '',
        glosa: '',
        ativo: 'true',
        guias: [],
      },
      mostrarAdicionar: true,
      mostrarAdicionadas: true,
      filtroGuias: {
        numero: '',
        convenio: '',
        pacienteId: '',
        dataInicio: '',
        dataFim: '',
        especialidade: '',
        evnviadaParaFaturamento: true,
        skip: 0,
        orderBy: 'autorizacao.dataEmissao',
        limit: 6,
        pagina: 1,
        total: 0,
      },
    }
  },
  validations: {
    faturamento: {
      nome: { required },
      ativo: { required },
    },
  },
  created() {
    this.recuperarPorId()
    this.pesquisarGuias()
  },
  methods: {
    toggleMostrarAdicionadas() {
      this.mostrarAdicionadas = !this.mostrarAdicionadas
    },
    toggleMostrarAdicionar() {
      this.mostrarAdicionar = !this.mostrarAdicionar
    },
    aoSelecionarPacienteFiltro(paciente) {
      this.filtroGuias.pacienteId = paciente._id
      this.pesquisarGuias()
    },
    aoLimparPacienteFiltro() {
      this.filtroGuias.pacienteId = ''
      this.pesquisarGuias()
    },
    atualizarFiltroGuiasNumero(numero) {
      this.filtroGuias.numero = numero
      this.pesquisarGuias()
    },
    atualizarFiltroGuiasConvenio(convenio) {
      this.filtroGuias.convenio = convenio
      this.pesquisarGuias()
    },
    atualizarFiltroGuiasDataInicio(dataInicio) {
      this.filtroGuias.dataInicio = dataInicio
      this.pesquisarGuias()
    },
    atualizarFiltroGuiasDataFim(dataFim) {
      this.filtroGuias.dataFim = dataFim
      this.pesquisarGuias()
    },
    atualizarFiltroGuiasEspecialidade(especialidade) {
      this.filtroGuias.especialidade = especialidade
      this.pesquisarGuias()
    },
    salvarHistoricoGuiasAdicionadas() {
      this.faturamento.guias.forEach((guia) => {
        guiaServico.adicionarEmPacoteFaturamento(guia._id)
      })
    },
    salvarHistoricoGuiasRemovidas() {
      this.guiasRemovidas.forEach((guia) => {
        guiaServico.removerDePacoteFaturamento(guia._id)
      })
    },
    recuperarPorId() {
      const id = this.$route.params.id

      if (id) {
        faturamentoServico.recuperar(id).then((res) => {
          this.faturamento = res.faturamento
          this.faturamento.ativo = this.faturamento.ativo.toString()
        })
      }
    },
    exibeFinalizar() {
      return this.faturamento._id && !this.faturamento.finalizado
    },
    salvar() {
      this.v$.$touch()

      if (this.v$.$invalid) {
        mensagemServico.cadastroInvalido(this.v$)
      } else {
        if (this.faturamento._id) {
          faturamentoServico
            .atualizar(this.faturamento._id, this.faturamento)
            .then((result) => {
              if (result.erro) {
                mensagemServico.alerta(result.erro.content, result.erro.title)
                return
              }

              this.salvarHistoricoGuiasAdicionadas()
              this.salvarHistoricoGuiasRemovidas()
            })
        } else {
          faturamentoServico.criar(this.faturamento).then((result) => {
            if (result.erro) {
              mensagemServico.alerta(result.erro.content, result.erro.title)
              return
            }

            this.faturamento = result.faturamento
            this.faturamento.ativo = this.faturamento.ativo.toString()
            this.salvarHistoricoGuiasAdicionadas()
            this.salvarHistoricoGuiasRemovidas()
            router.replace({
              name: 'FaturamentoCadastro',
              params: { id: this.faturamento._id },
            })
          })
        }
      }
    },
    finalizarFaturamento() {
      if (!this.faturamento._id || this.faturamento.finalizado) {
        return
      }

      this.faturamento.finalizado = new Date()
      this.$nextTick()
      faturamentoServico
        .atualizar(this.faturamento._id, this.faturamento)
        .then((result) => {
          if (result.erro) {
            mensagemServico.alerta(result.erro.content, result.erro.title)
            return
          }

          this.faturamento.guias.forEach((guia) => {
            guiaServico.adicionaGuiaFaturada(guia._id)
          })

          router.replace({ name: 'Faturamento' })
        })
    },
    selecionarAgendamentos(dados) {
      const guiaId = dados.guia._id
      const agendamentos = dados.agendamentos
      const guia = this.faturamento.guias.find((g) => g._id === guiaId)
      guia.agendamentos = agendamentos
    },
    removerGuia(guia) {
      const index = this.faturamento.guias.indexOf(guia)
      this.faturamento.guias.splice(index, 1)
      this.guiasRemovidas.push(guia)
    },
    adicionarGuiaSelecionadas() {
      if (this.guiasSelecionadas.length) {
        let msgErro = ''

        this.guiasSelecionadas.forEach((g) => {
          const existe = this.faturamento.guias.find(
            (gf) =>
              gf.autorizacao.numeroGuia.toString() === g.autorizacao.numeroGuia
          )

          if (existe) {
            msgErro += `Guia ${g.autorizacao.numeroGuia} já adicionada.\n`
          } else if (g.agendamentos.length === 0) {
            msgErro += `Guia ${g.autorizacao.numeroGuia} não possui agendamentos.\n`
          } else {
            this.faturamento.guias.push(g)
          }
        })

        if (msgErro) {
          mensagemServico.alerta(msgErro)
        }

        this.limparFiltroGuias()
      }
    },
    guiaToggle(dados) {
      if (dados.toggle) {
        this.guiasSelecionadas.push(dados.guia)
      } else {
        const index = this.guiasSelecionadas.indexOf(dados.guia)
        this.guiasSelecionadas.splice(index, 1)
      }
    },
    paginaAlterada(pagina) {
      this.filtroGuias.pagina = pagina
      this.filtroGuias.skip = this.filtroGuias.limit * (pagina - 1)
      this.pesquisarGuias()
    },
    limparFiltroGuias() {
      this.filtroGuias = {
        numero: '',
        convenio: '',
        pacienteId: '',
        dataInicio: '',
        dataFim: '',
        especialidade: '',
        evnviadaParaFaturamento: true,
        skip: 0,
        orderBy: 'autorizacao.dataEmissao',
        limit: 6,
        pagina: 1,
        total: 0,
      }
      this.guias = []
      this.guiasSelecionadas = []
      this.pesquisarGuias()
    },
    pesquisarGuias() {
      this.filtroGuias.pagina =
        typeof skip === 'undefined' ? 1 : this.filtroGuias.pagina

      guiaServico.total(this.filtroGuias).then((result) => {
        this.filtroGuias.total = Math.ceil(
          result.total / this.filtroGuias.limit
        )

        if (this.filtroGuias.total) {
          guiaServico.recuperarTodos(this.filtroGuias).then((result) => {
            this.guias = result.guias
          })
        } else {
          this.guias = []
        }
      })
    },
  },
}
</script>

<style>
nav#paginadorGuiasFaturamento ul {
  margin: 0;
}

span.contador {
  display: block;
  float: left;
  padding: 0 4px;
  margin: -4px -8px 0 0;
  font-weight: 600;
  color: #008080;
  text-align: center;
  background: #fff;
  border: 4px solid white;
  border-radius: 46%;
}
</style>
